import { ModalHandler } from '@app-velocity/ui';

import { ContactTeamAdminModalContent } from './components/ContactTeamAdminModalContent';

export const ContactTeamAdminModal = () => {
  return (
    <ModalHandler channel="users" id="contact-team-admin">
      <ContactTeamAdminModalContent />
    </ModalHandler>
  );
};
